export default __webpack_public_path__ + "static/rh-white-montserrat-v7-aa09ddd10bd78f42e4518c65cdb08920.png";